import getTimeOffDates from './getTimeOffDates';
import getPartialDuration from './getPartialDuration';
import utils from '../utils';
import context from '../context';
import { DISPLAY_MODES } from '../constants';

export default function getEventDays(event, displayMode, relevantDays, { cache = false } = {}) {
  let cacheKey;
  if (cache) {
    cacheKey = `cachedEventDays_${displayMode}_${relevantDays.join(',')}`;
  }

  if (cache && event[cacheKey]) {
    return event[cacheKey];
  }

  let result;

  if (context.isTimeOff(event.type) || event.type === 'availability') {
    result = getTimeOffDates(event, displayMode, relevantDays);
  } else {
    result = getShiftDates(event, displayMode, relevantDays);
  }

  if (cache) {
    event[cacheKey] = result;
  }

  return result;
}

function getShiftDates(event, displayMode, relevantDays) {
  const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;

  const days = utils
    .getBusinessDaysBetween(visibleHoursStart, visibleHoursEnd, event, relevantDays)
    .map(utils.getRealDate);

  if (displayMode === DISPLAY_MODES.DAY) {
    return days;
  }

  const dtstartDateString = utils.formatDate(event.dtstart);
  if (!days.map(utils.formatDate).includes(dtstartDateString)) {
    days.push(utils.getRealDate(dtstartDateString));

    return days.sort((a, b) => a.getTime() - b.getTime());
  }

  if (
    days.length === 1 &&
    getPartialDuration(event, 1, context.laborCostSettings?.shiftSplitTime)
  ) {
    days.push(utils.addDays(days[0], 1));
  }

  return days;
}
